import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    timeout: 15000,
});

const ADMIN_TOKEN_KEY = "shh-admin-token";
export const getAdminToken = () => {
    try { return localStorage.getItem(ADMIN_TOKEN_KEY) || ""; } catch (_) { return ""; }
};
export const setAdminToken = (t) => {
    try { localStorage.setItem(ADMIN_TOKEN_KEY, t); } catch (_) {}
};
export const clearAdminToken = () => {
    try { localStorage.removeItem(ADMIN_TOKEN_KEY); } catch (_) {}
};

const adminHeaders = () => ({ headers: { "X-Admin-Token": getAdminToken() } });

export const submitLead = (data) => api.post("/leads", data).then((r) => r.data);
export const subscribeNewsletter = (email) =>
    api.post("/newsletter", { email }).then((r) => r.data);
export const submitContact = (data) =>
    api.post("/contact", data).then((r) => r.data);

// Admin endpoints — require X-Admin-Token
export const getStats = () => api.get("/stats", adminHeaders()).then((r) => r.data);
export const getLeads = (limit = 500) => api.get(`/leads?limit=${limit}`, adminHeaders()).then((r) => r.data);
export const getContactMessages = (limit = 500) => api.get(`/contact?limit=${limit}`, adminHeaders()).then((r) => r.data);
